module.exports = require("original-require");


//////////////////
// WEBPACK FOOTER
// external "original-require"
// module id = 256
// module chunks = 0